import { render, staticRenderFns } from "./ProductHeightsList.vue?vue&type=template&id=1e25b94f&scoped=true&"
import script from "./ProductHeightsList.vue?vue&type=script&lang=js&"
export * from "./ProductHeightsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeightsList.vue?vue&type=style&index=0&id=1e25b94f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e25b94f",
  null
  
)

export default component.exports